module.exports = __webpack_public_path__ + "img/04.91414949.jpg";